// src/pages/Appointment.js
import React from 'react';
import { Navigate } from 'react-router-dom';

function Appointment() {
  return <Navigate to="/home#schedule-overview" replace />;
}

export default Appointment;